var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoAccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_244_2369)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.75 13.6667H29.0417V10.25C29.0417 5.53498 25.215 1.70831 20.5 1.70831C15.785 1.70831 11.9583 5.53498 11.9583 10.25V13.6667H10.25C8.37081 13.6667 6.83331 15.2042 6.83331 17.0833V34.1667C6.83331 36.0458 8.37081 37.5833 10.25 37.5833H30.75C32.6292 37.5833 34.1667 36.0458 34.1667 34.1667V17.0833C34.1667 15.2042 32.6292 13.6667 30.75 13.6667ZM20.5 29.0417C18.6208 29.0417 17.0833 27.5042 17.0833 25.625C17.0833 23.7458 18.6208 22.2083 20.5 22.2083C22.3792 22.2083 23.9167 23.7458 23.9167 25.625C23.9167 27.5042 22.3792 29.0417 20.5 29.0417ZM15.375 13.6667V10.25C15.375 7.41415 17.6642 5.12498 20.5 5.12498C23.3358 5.12498 25.625 7.41415 25.625 10.25V13.6667H15.375Z",
    fill: "#834FF1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_244_2369"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 41,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoAccess);
export default __webpack_public_path__ + "static/media/NoAccess.332ad9bb8ba58c8f4564674ced40ccdb.svg";
export { ForwardRef as ReactComponent };